import { render, staticRenderFns } from "./ButtonHistory.vue?vue&type=template&id=2dcfa785&scoped=true&"
import script from "./ButtonHistory.vue?vue&type=script&lang=js&"
export * from "./ButtonHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcfa785",
  null
  
)

export default component.exports